import { lazy } from 'react';

export const ModalConfirmation = lazy(() => import('./ModalConfirmation'));
